import Authentication from '../Views/Authentication.svelte';
import Dashboard from '../Views/Dashboard.svelte';
import Maintenance from '../Views/Maintenance.svelte';
import Manage from '../Views/Manage.svelte';
import Profile from '../Views/Profile.svelte';
import Subscription from '../Views/Subscription.svelte';
import {writable} from 'svelte/store';

const mapping = {
	authentication: Authentication,
	dashboard: Dashboard,
	maintenance: Maintenance,
	manage: Manage,
	profile: Profile,
	subscription: Subscription
};

let content = {code: 'authentication', component: Authentication, config: {}};
const view = writable(content);

view.setView = (code, config) => {
	content.code = code;
	content.component = mapping[code];
	content.config = config ? config : {};
	view.set(content);
	window.scrollTo({top: 0, behavior: 'smooth'});
};

view.getIs = code => {
	return content.code === code;
};

export default view;